import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    classes: ['ar_category', ...superMeta.classes],
    mapProp: 'algMap',
}
